import { apis } from '@/config';
import { api } from '@/api/api';
import { config } from 'env_def';
const stage = config('stage');
const MAX_OPEN_TIME = 4;
class NpsApiImpl {
    constructor() {
        this.name = apis.npsImpl;
        this.eventApi = api.getEventApi();
        this.systemApi = api.getSystemApi();
        this.storeApi = api.getDataStoreApi();
        this.httpApi = api.getDataTransApi();
    }
    getNextOpenTime(item) {
        const { openCount = 0, lastUpdateTime } = item;
        if (openCount <= 2) {
            return lastUpdateTime + (stage === 'prod' ? 1000 * 60 * 60 * 24 * 3 : 1000 * 60 * 3);
        }
        else {
            return lastUpdateTime + (stage === 'prod' ? 1000 * 60 * 60 * 24 * 6 : 1000 * 60 * 6);
        }
    }
    init() {
        return this.name;
    }
    getShouldAutoOpen(item) {
        if (!item)
            return false;
        if (item.noAutoOpen)
            return false;
        if (item.openCount && item.openCount > MAX_OPEN_TIME) {
            return false;
        }
        if (this.getNextOpenTime(item) > Date.now()) {
            return false;
        }
        return true;
    }
    async getNPSItem() {
        try {
            const isMainPage = this.systemApi.isMainPage();
            if (!isMainPage)
                return null;
            const url = this.systemApi.getUrl('getNpsItem');
            const { data } = await this.httpApi.get(url);
            if (data && data.data) {
                const currentUser = this.systemApi.getCurrentUser();
                const lastUpdateTime = data.data.lastUpdateTime;
                const openCount = data.data.count || 0;
                const userId = data.data.userId;
                const item = data.data.data;
                item.lastUpdateTime = lastUpdateTime;
                item.openCount = openCount;
                item.userId = userId;
                item.userName = (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id) || '';
                return item;
            }
            return null;
        }
        catch (ex) {
            console.error(`getNPSItem-catch`, ex);
            return null;
        }
    }
    async updateNpsStatus(npsId, status) {
        try {
            const url = this.systemApi.getUrl('updateNpsStatus');
            const { data } = await this.httpApi.post(url, { nspRecordId: npsId, npsStatus: status }, { contentType: 'json' });
            if (data && data.success) {
                return true;
            }
            return false;
        }
        catch (ex) {
            console.error(`updateNpsStatus-catch`, ex);
            return false;
        }
    }
    async intervalUpdateNpsStatus() {
        const currentUser = this.systemApi.getCurrentUser();
        if (!currentUser)
            return;
        const item = await this.getNPSItem();
        let eventData = {};
        if (item === null) {
            eventData = {
                show: false,
                item: null,
                autoOpen: false,
            };
        }
        else {
            let autoOpen = false;
            if (this.getShouldAutoOpen(item)) {
                autoOpen = true;
            }
            eventData = {
                show: true,
                item: item,
                autoOpen,
            };
        }
        this.eventApi.sendSysEvent({
            eventName: 'npsShowStatusChange',
            eventData,
        });
    }
    getDelayTime() {
        return 1000 * 30;
    }
    afterLoadFinish() {
        if (!process.env.BUILD_ISEDM)
            return this.name;
        const isMainPage = this.systemApi.isMainPage();
        if (!isMainPage)
            return this.name;
        setTimeout(() => {
            this.intervalUpdateNpsStatus();
        }, this.getDelayTime());
        this.systemApi.intervalEvent({
            seq: 0,
            id: 'intervalGetNpsStatus',
            eventPeriod: 'extLong',
            handler: ev => {
                if (ev.seq > 0 && ev.seq % 2 === 0) {
                    this.intervalUpdateNpsStatus();
                }
            },
        });
        return this.name;
    }
    checkItem(item) {
        if (item) {
            const nowTs = new Date().getTime();
            if (nowTs > item.endTime || nowTs < item.startTime || !item.npsId) {
                return false;
            }
            return true;
        }
        return false;
    }
}
const impl = new NpsApiImpl();
api.registerLogicalApi(impl);
export default impl;
